import { render } from "./TransactionCategory.vue?vue&type=template&id=3cae2acc"
import script from "./TransactionCategory.vue?vue&type=script&lang=js"
export * from "./TransactionCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__